function CourseSchedule() {
  const style = { height: "80vh", width: "95%" };
  return (
    <div>
      <iframe
        title="Course_Schedule"
        style={style}
            
        src="https://docs.google.com/spreadsheets/d/1DeiAo8fWy7oztomXOoOMGTnqQ6yCzaGYK7yN7qW_vYM/htmlembed"
      />
      <br />
      Open it via {" "}
      <a
        className="" 
        target="_blank"
        href="https://docs.google.com/spreadsheets/d/1DeiAo8fWy7oztomXOoOMGTnqQ6yCzaGYK7yN7qW_vYM"
      >
        Google Docs
      </a>
    </div>
  );
}

export default CourseSchedule;
